import {CLEAR_SETTLEMENT, FETCH_SETTLEMENT, LIST_SETTLEMENT, LOADING_SETTLEMENT, MODIFIED_SETTLEMENT} from "./types";

const init = {
    isLoading: false,
    data: {
        settlements: undefined,
        summery: undefined,
        isEditable: true
    },
    filter: {}
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_SETTLEMENT:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_SETTLEMENT:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        case CLEAR_SETTLEMENT:
            return {
                isLoading: false,
                data: []
            };
        case MODIFIED_SETTLEMENT:
            return {
                ...state,
                isLoading: true
            };
        case LOADING_SETTLEMENT:
            return {
                ...state,
                isLoading: false
            };
        default:
            return state;
    }
}